import React, { ComponentProps } from "react";
import { TableContainer as ChakraTableContainer, Th as ChakraTh } from "@chakra-ui/react";

/**
 * A standardised custom Th implementation of the Chakra component is required because the default font size is not taking effect. See src/theme/components/table.ts
 */
export function Th({ children, ...props }: ComponentProps<typeof ChakraTh>): JSX.Element {
	return (
		<ChakraTh fontSize={13} letterSpacing={0.4} {...props}>
			{children}
		</ChakraTh>
	);
}

/**
 * A standardised implementation of the TableContainer component from Chakra UI.
 * Promotes consistency across the application given there is no good way to style this globally in the theme.
 */
export function TableContainer({ children }: ComponentProps<typeof ChakraTableContainer>): JSX.Element {
	return (
		<ChakraTableContainer width="100%" borderWidth="1px" borderColor="neutrals.40" borderRadius="lg">
			{children}
		</ChakraTableContainer>
	);
}
